export const initStateCustomers = (
   Object.assign({
      data           : [],
      customer_name  : '',
      personal_phone : '',
      email          : '',
      address        : '',
      actionForm     : false,
      customerId     : ''
   })
);